import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4">
      <div className="text-center max-w-md">
        {/* Big 404 */}
        <p className="text-[120px] leading-none font-black text-gray-100 select-none">404</p>

        <div className="-mt-4">
          <p className="text-5xl mb-4">🍽</p>
          <h1 className="font-serif text-3xl font-bold text-gray-900 mb-3">
            Oops! Page Not Found
          </h1>
          <p className="text-gray-400 text-sm mb-8 leading-relaxed">
            Looks like this page went out for delivery and never came back.
            <br />
            Let's get you back on track.
          </p>

          <div className="flex gap-3 justify-center flex-wrap">
            <button
              onClick={() => navigate(-1)}
              className="bg-gray-100 text-gray-700 font-bold px-6 py-3 rounded-2xl hover:bg-gray-200 transition"
            >
              ← Go Back
            </button>
            <Link
              to="/"
              className="bg-[#f97316] text-white font-bold px-6 py-3 rounded-2xl hover:bg-orange-600 transition"
            >
              🏠 Home
            </Link>
            <Link
              to="/menu"
              className="bg-orange-50 text-[#f97316] font-bold px-6 py-3 rounded-2xl hover:bg-orange-100 transition"
            >
              Browse Menu
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
